import { render, staticRenderFns } from "./WxVideoPlayer.vue?vue&type=template&id=c953c168&scoped=true"
import script from "./WxVideoPlayer.vue?vue&type=script&lang=js"
export * from "./WxVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c953c168",
  null
  
)

export default component.exports